(() => {

    const STORAGE_KEY = 'nwt-progress-widths';
    let previousWidths = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');

    function animateProgressBars(root = document) {
        const bars = root.querySelectorAll('.nwt-progress-segment-fill');
        // console.log('bars');

        // non quando arriva il change, ma quando lupdate del carrello è finalizzato.
        
        if (!bars.length) return;

        const currentWidths = {};

        bars.forEach(bar => {

            const id = bar.dataset.segment;
            const target = parseFloat(bar.dataset.target);

            currentWidths[id] = target;

            const start = previousWidths[id];

            // primo render: niente animazione
            if (start === undefined) {
                bar.style.width = target + '%';
                return;
            }

            // imposto la larghezza precedente
            bar.style.transition = 'none';
            bar.style.width = start + '%';

            // forzo il reflow
            bar.offsetWidth;
            // console.log(target > 100 ? '100%' : target + '%', bar);
            
            if(target < 100) {
              bar.style.transition = 'width .45s cubic-bezier(.22,.61,.36,1)';
            }
            bar.style.width = target > 100 ? '100%' : target + '%';

            // requestAnimationFrame(() => {
            //     bar.style.transition = 'width .45s cubic-bezier(.22,.61,.36,1)';
            //     bar.style.width = target + '%';
            // });

        });

        previousWidths = currentWidths;
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(currentWidths));

    }

    // primo caricamento
    animateProgressBars();

    // osserva il DOM
    // const observer = new MutationObserver(mutations => {

    //     let shouldAnimate = false;

    //     mutations.forEach(mutation => {

    //         mutation.addedNodes.forEach(node => {

    //             if (!(node instanceof HTMLElement)) return;

    //             if (
    //                 node.matches?.('.nwt-progress-segment-fill') ||
    //                 node.querySelector?.('.nwt-progress-segment-fill')
    //             ) {
    //                 shouldAnimate = true;
    //             }

    //         });

    //     });

    //     if (shouldAnimate) {
    //         requestAnimationFrame(() => animateProgressBars());
    //     }

    // });

    // observer.observe(document.body, {
    //     childList: true,
    //     subtree: true
    // });

     document.addEventListener('DOMContentLoaded', () => {
    animateProgressBars();
  });
  
  // document.addEventListener('change', (e) => {
  //   if(e.target.closest('.drawer__inner')) {
  //     console.log('cart- change');
      
  //     animateProgressBars();
  //   }
  // });

  document.addEventListener('nwt-cart:updated', () => {
    console.log('nwt-cart:updated');
    
      animateProgressBars();
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // console.log('Cart aggiornato');
      // console.log(event);

      const cartData = event.cartData;
      const variantId = event.variantId;

      // qui richiami la tua animazione
      animateProgressBars();
    });

  document.addEventListener('shopify:section:load', e => {
    animateProgressBars(e.target);
  });

})();
